// ============================================================================
// FRENCH TRANSLATIONS - UI
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'fr',
    languageName: 'Franêais',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST Chroniques\nde l'Amour",
    subtitle: "Découverte interactive des Écritures",
    tagline: "Marcher vers la lumiïre divine",
    menu: "Menu",
    retry: "Réessayer"
  },
  
  buttons: {
    play: "JOUER",
    back: "Retour",
    continue: "Continuer",
    restart: "Recommencer",
    close: "Fermer",
    nextLevel: "Niveau Suivant",
    selectLevel: "Sélection des Niveaux",
    retry: "Réessayer",
    mainMenu: "Menu Principal",
    start: "Commencer",
    cancel: "Annuler",
    confirm: "Confirmer",
    save: "Sauvegarder",
    load: "Charger",
    yesRestart: "Oui, recommencer",
    noContinue: "Non, continuer",
    tryAgain: "Réessayer",
    backToMenu: "Retour au menu"
  },
  
  labels: {
    score: "Score",
    stars: "étoiles",
    wisdom: "Sagesse",
    revelation: "Révélation",
    lives: "Vies",
    combo: "Combo",
    level: "NIVEAU",
    easy: "FACILE",
    medium: "MOYEN",
    hard: "DIFFICILE",
    correct: "Correct !",
    gameOver: "épreuve échouée",
    victory: "Victoire !",
    completed: "Complété",
    rank: "Rang Spirituel",
    points: "Points de Sagesse",
    unlockedLevels: "niveau(x) débloqué(s)",
    questionOfKnowledge: "Question de Connaissance",
    hintOfWisdom: "Indice de Sagesse",
    knowledgeMastered: "Connaissance Maîtrisée !",
    knowledgeAcquired: "Connaissance acquise !",
    testFailed: "épreuve échouée",
    wisdomBonus: "Bonus",
    xpGained: "XP",
    newRank: "Nouveau rang",
    nextGrade: "Prochain grade",
    maxLevelReached: "Niveau maximum atteint !",
    wrongAnswer: "Mauvaise réponse !"
  },
  
  menu: {
    playButton: "JOUER",
    info: "Info",
    treasures: "Trésors",
    john: "Jean",
    reset: "Reset",
    restart: "🔄 Recommencer l'aventure ?",
    confirmReset: "Es-tu sûr de vouloir effacer toute ta progression ?",
    youWillLose: "Tu perdras :",
    wisdomPoints: "Points de Sagesse",
    starsCollected: "étoiles collectées",
    levelsUnlocked: "niveau(x) débloqué(s)",
    spiritualRank: "Rang Spirituel",
    newAdventure: "🌟 Nouvelle Aventure",
    readyToStart: "Prèt à commencer ?",
    startJourney: "Commence ton voyage dans la connaissance des Écritures !",
    audioControls: "Contrôles audio",
    mute: "Couper le son",
    unmute: "Activer le son",
    close: "Fermer",
    language: "Langue",
    restartGame: "Redémarrer le jeu"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "Aventure biblique interactive",
    anonymousMode: "Jouer en Anonyme",
    anonymousDesc: "Choisissez un pseudo",
    emailMode: "Connexion Email",
    emailDesc: "Sauvegarde multi-appareils",
    pseudo: "Pseudo",
    pseudoPlaceholder: "Votre pseudo...",
    email: "Adresse Email",
    emailPlaceholder: "votre@email.com",
    startPlaying: "Commencer à jouer",
    sendLink: "Envoyer le lien",
    sending: "Envoi...",
    connecting: "Connexion...",
    back: "Retour",
    localSave: "Votre progression sera sauvegardée localement",
    cloudSync: "Pas de mot de passe requis • Synchronisation cloud",
    magicLink: "Recevez un lien magique par email",
    checkEmail: "📧 Vérifiez votre email ! Un lien de connexion vous a été envoyé.",
    checkSpam: "Vérifiez aussi vos spams/courriers indésirables",
    waitingConnection: "En attente de connexion...",
    errorSend: "Erreur d'envoi du lien",
    rateLimited: "⏳ Veuillez patienter 15 secondes avant de renvoyer un email",
    importSession: "🔄 Importer session depuis production",
    errorConnection: "Erreur de connexion",
    enterPseudo: "Veuillez entrer un pseudo",
    enterEmail: "Veuillez entrer un email valide",
    // Tooltips
    never: "Jamais",
    save: "Sauvegarder la partie",
    lastSave: "dernière",
    refresh: "Recharger la progression",
    logout: "Se déconnecter",
    connectToCloud: "Se connecter pour sauvegarder en ligne",
    editPseudo: "Modifier le pseudo",
    confirm: "Confirmer",
    cancel: "Annuler",
    close: "Fermer",
    passwordMode: "Connexion simple",
    passwordDesc: "Email + mot de passe",
    password: "Mot de passe",
    passwordPlaceholder: "Minimum 6 caractères",
    passwordMinLength: "Minimum 6 caractères",
    playWithoutAccount: "Jouer sans compte",
    forgotPassword: "Mot de passe oublié ?",
    resetPasswordTitle: "Réinitialiser le mot de passe",
    resetPasswordSubtitle: "Entrez votre email pour recevoir un lien de réinitialisation",
    sendResetLink: "Envoyer le lien",
    resetEmailSent: "📧 Email de réinitialisation envoyé ! Vérifiez votre boîte mail.",
    errorReset: "Erreur lors de l'envoi de l'email",
    backToSignin: "Retour à la connexion",
    newPassword: "Nouveau mot de passe",
    enterNewPassword: "Choisissez un nouveau mot de passe sécurisé",
    confirmPassword: "Confirmer le mot de passe",
    updatePassword: "Mettre à jour le mot de passe",
    passwordsDontMatch: "Les mots de passe ne correspondent pas",
    passwordUpdateSuccess: "✅ Mot de passe mis à jour avec succès !",
    errorUpdatePassword: "Erreur lors de la mise à jour du mot de passe",
    resetLinkExpired: "Lien de réinitialisation expiré ou invalide",
    forgotPassword: "Mot de passe oublié ?",
    signup: "Inscription",
    signin: "Connexion",
    createAccount: "Créer un compte",
    signupInfo: "Remplissez le formulaire ci-dessous",
    passwordInfo: "Accès rapide avec mot de passe",
    signupButton: "Créer mon compte",
    signinButton: "Se connecter",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
    emailAlreadyExists: "Cet email est déjà utilisé",
    emailExistsHint: "✉️ Cet email est déjà enregistré. Essayez de vous connecter ! (Peut-être créé depuis un autre jeu?)",
    switchToSignin: "🔑 Passez en mode Connexion avec votre email existant",
    invalidCredentials: "Email ou mot de passe incorrect",
    signupSuccess: "📧 Compte créé ! Vérifiez votre email pour confirmer votre inscription.",
    emailConfirmationRequired: "Vérifiez votre email",
    checkSpamFolder: "Vérifiez aussi vos spams",
    connectionSuccess: "✅ Connexion réussie !",
    errorSignup: "Erreur lors de l'inscription"},
  
  install: {
    title: "Installer l'application",
    subtitle: "Accès rapide et hors ligne",
    feature1: "Lancement instantané depuis votre écran d'accueil",
    feature2: "Fonctionne hors ligne après installation",
    feature3: "Expérience application native",
    feature4: "Aucun téléchargement de store requis",
    install: "Installer",
    dismiss: "Plus tard",
    info: "Vous pourrez désinstaller l'app à tout moment"
  },
  
  ranks: {
    seeker: "Chercheur",
    believer: "Éveillé",
    disciple: "Disciple",
    servant: "Serviteur",
    witness: "Témoin",
    guardian: "Gardien",
    wise: "Sage",
    prophet: "Prophète",
    apostle: "Apôtre",
    seekerDesc: "Début du voyage spirituel",
    believerDesc: "Conscience spirituelle éveillée",
    discipleDesc: "Apprentissage des enseignements",
    servantDesc: "Service et dévotion",
    witnessDesc: "Partage de la foi",
    guardianDesc: "Protection de la vérité",
    wiseDesc: "Sagesse et connaissance",
    prophetDesc: "Vision spirituelle",
    apostleDesc: "Maître spirituel"
  },

  spiritualJourney: {
    beginning: "Début du voyage spirituel",
    progress: "Progression spirituelle",
    grade: "Grade",
    xp: "XP",
    level: "Niveau",
    nextGrade: "Prochain grade",
    still: "Encore",
    maxLevelReached: "Niveau Maximum Atteint !",
    masteredAllTeachings: "Vous avez maîtrisé tous les enseignements",
    progression: "Progression"
  },
  
  treasures: {
    title: "📖 Les Trésors de la Bible",
    verse: "Verset du jour",
    fact: "Le saviez-vous ?",
    treasure: "🎁 Trésor caché",
    question: "Question rigolote",
    newTreasure: "Nouveau trésor",
    context: "Contexte",
    strongReference: "Référence biblique pour étude approfondie",
    johnGospelDescription: "L'évangile de Jean révèle la divinité de Jésus à travers 21 chapitres inspirants.",
    availableInLanguages: "Disponible en 14 langues",
    johnGospelTitle: "Évangile de Jean",
    johnGospelStats: "21 chapitres • 878 versets • 14 langues",
    bibleReaderStrong: "Lecteur Bible + Strong",
    bibleReaderStrongDesc: "Lecture complète avec dictionnaire Strong",
    johnTreasures: "Trésors de Jean",
    johnTreasuresDesc: "Trésors bibliques et anecdotes intéressantes",
    johnBibleReader: "Lecteur Bible Jean + Strong",
    emmanuelMemo: "Mémo d'Emmanuel",
    emmanuelMessage: "Vous êtes arrivés en haut de la montagne, et la connaissance est acquise. Mais la foi inébranlable demande de l'expérience de vie, de la miséricorde et du véritable amour de Jésus. Les diverses épreuves de la vie testeront votre voie, le vrai chemin que l'on choisit, notre cœur. Nous restons imparfaits, nos désirs sont nombreux, et l'amour du gain ou de notre confort personnel devient trop souvent notre priorité égoïste. Demandez à Dieu la sagesse, son amour, sa force, et reconnaissez vos faiblesses humblement, car on ne peut rien Lui cacher… Rien. Inutile de voyager en mode privé, en VPN, ou même d'effacer l'historique. Jeûnez comme Daniel : privez-vous un moment de ce que vous aimez le plus, dans le calme et la sagesse. Cela vous permettra de mieux entendre Dieu, d'avoir une disposition de cœur prête aux transformations profondes — et souvent douloureuses. Alors, les rêves et les songes deviendront plus clairs, comme pour Joseph. Mais gardez-vous de l'orgueil : ne cédez pas au « j'ai toujours raison » ou au « je connais mieux ». Car la révélation de Dieu est une grâce extraordinaire. Ne devenez pas un docteur de la Loi, capable de crucifier encore Jésus aujourd'hui, Lui qui demande simplement d'aimer votre prochain… et de lui accorder la même liberté que vous-même recevez. Avoir la foi, c'est entrer dans une relation et un cheminement libre du cœur. Elle fera de vous des héros puissants, capables de l'impossible. Car l'expérience du surnaturel, la présence de Dieu, sa confirmation ou sa bénédiction vous rendra vraiment inébranlables.",
    clarification: "Clarification importante",
    bibleOffline: "Lire la Bible Offline",
    bibleStudy: "Étude biblique",
    version: "Version",
    openReader: "Ouvrir le lecteur",
    features: "Fonctionnalités"
  },
  
  messages: {
    chooseCard: "🃏 Choisis ta carte de pouvoir",
    cardHelp: "Elle t'accompagnera pour les 3 questions de ce niveau",
    chooseAnswer: "📖 Choisis ta réponse :",
    wrongAnswer: "❌ Mauvaise réponse ! Il te reste {lives} vie(s). Essaie encore !",
    levelCompleted: "Niveau {level} Complété",
    questionsProgress: "Question {current} sur {total}",
    starsCollected: "étoiles collectées : {current}/{total}",
    pointsEarned: "+{points} Points de Sagesse",
    secondChance: "🔥 Votre carte COURAGE vous donne une seconde chance ! Réessayez avec sagesse.",
    bonusApplied: "🃏 Bonus {card} : +{percent}% ({base} → {final})",
    defeatedQuote: "Je puis tout par celui qui me fortifie",
    perfect: "🃏 Parfait",
    good: "✅ Bien",
    start: "✅ Début",
    secretLevel: "🔓 NIVEAU SECRET DÉBLOQUÉ!",
    secretChapter: "🎁 Chapitre Secret",
    returnToLevels: "Retour",
    next: "Suivant",
    retry: "Réessayer",
    menu: "Menu",
    chapter: "Chapitre",
    chapterStars: "étoiles du chapitre",
    totalGlobal: "Total global",
    backToMenu: "Retour au Menu"
  },
  
  chapters: {
    "1": "La Genïse",
    "2": "L'Exode",
    "3": "Jésus-Christ",
    "4": "Crucifixion/Résurrection",
    "5": "Église primitive",
    "6": "Missions de Paul",
    "7": "Lettres/Apocalypse",
    "8": "Niveau Bonus"
  },
  
  cards: {
    faith: "FOI",
    courage: "COURAGE",
    wisdom: "SAGESSE",
    faithKnowledge: "+50% points",
    courageKnowledge: "Seconde chance",
    wisdomKnowledge: "Indice + bonus",
    faithDesc: "Maximum de points de sagesse obtenus",
    courageDesc: "Points normaux mais seconde chance",
    wisdomDesc: "Indice révélé et +25% points",
    chooseCard: "🃏 Choisis un don de connaissance",
    cardEffects: "🃏 Effets des dons de connaissance :",
    faithEffect: "+50% points de sagesse - Maximum de récompense",
    courageEffect: "Points normaux mais seconde chance sur erreur",
    wisdomEffect: "+25% points + indice révélé pour chaque question",
    chooseWisely: "Choisis avec sagesse, car ton choix t'accompagnera tout au long du niveau"
  },
  
  challenge: {
    loading: "Chargement du niveau...",
    peace: "🕊️ Que la paix repose dans ta maison",
    questionsAwaiting: "📚 3 questions de connaissance t'attendent",
    starsQuote: "Chaque étoile est une étape vers la lumiïre divine"
  },
  
  info: {
    title: "Unity Quest Chronicles of Peace",
    subtitle: "Découverte interactive des Écritures",
    yourStats: "Vos Statistiques",
    score: "Score",
    wisdom: "Sagesse",
    revelation: "Révélation",
    createdWith: "Créé avec ❤️",
    creator: "Emmanuel Payet",
    developerPassionate: "Développeur passionné de spiritualité",
    artistModule: "Emmanuel Artiste",
    artistPortfolio: "Portfolio artistique et créations numériques",
    features: "Fonctionnalités",
    multipleChapters: "91 niveaux répartis en 8 chapitres bibliques",
    powerCards: "3 cartes de pouvoir uniques (Foi, Courage, Sagesse)",
    progressionSystem: "Système de progression avec rangs spirituels",
    bibleTreasures: "Trésors bibliques et faits intéressants",
    howToPlay: "Comment Jouer",
    selectLevel: "Sélectionnez un niveau débloqué",
    choosePowerCard: "Choisissez votre carte de pouvoir",
    answerQuestions: "Répondez aux 3 questions de connaissance",
    earnStars: "Gagnez des étoiles selon vos vies restantes",
    tips: "Astuces",
    readCarefully: "Lisez attentivement chaque question",
    useWisdomCard: "Utilisez la carte Sagesse pour des indices",
    courageGivesSecondChance: "La carte Courage vous donne une seconde chance",
    faithMaximizes: "La carte Foi maximise vos points",
    johnGospelTitle: "Évangile de Jean",
    johnGospelStats: "21 chapitres • 878 versets • 14 langues",
    bibleReaderStrong: "Lecteur Bible + Strong",
    bibleReaderStrongDesc: "Lecture complète avec dictionnaire Strong",
    johnTreasures: "Trésors de Jean",
    johnTreasuresDesc: "Trésors bibliques et anecdotes intéressantes",
    quickAccessChapters: "Accès rapide aux chapitres célèbres:",
    johnChapter1: "Prologue",
    johnChapter3: "Naître de nouveau",
    johnChapter14: "Je suis le chemin",
    johnChapter20: "Résurrection",
    version: "Version",
    madeWithLove: "Fait avec amour pour la gloire de Dieu",
    backToMenu: "Retour au Menu"
  },
  
  bible: {
    readerTitle: "📖 Lecteur Bible",
    johnReaderTitle: "Lecteur Bible - Évangile de Jean",
    john: "Jean",
    loading: "Chargement des Écritures...",
    loadingChapter: "Chapitre {chapter} de l'Évangile de Jean. Les données complètes sont en cours de chargement...",
    exploreWhileLoading: "En attendant, vous pouvez explorer les autres chapitres ou utiliser la fonction de recherche.",
    menu: "Menu",
    tabBible: "Bible",
    tabUnity: "Unité",
    strong: "Strong",
    strongReferences: "Références Strong",
    verses: "versets",
    previous: "Précédent",
    next: "Suivant",
    strongDefinition: "Référence Strong",
    word: "Mot original",
    transliteration: "Translittération",
    close: "Fermer",
    share: "Partager",
    shareVerse: "Partager ce verset",
    shareSelection: "Partager la sélection",
    pronunciation: "Prononciation",
    meaning: "Signification",
    definition: "Définition complïte",
    usage: "Usage biblique",
    etymology: "étymologie",
    search: "Rechercher...",
    definitionNotFound: "Définition non trouvée",
    definitionLoading: "Définition à charger...",
    imageFeatureComing: "🖼️ Fonctionnalité d'image à venir !",
    copyError: "Erreur lors de la copie:",
    error: "❌ Erreur",
    errorLoading: "Erreur de chargement",
    retry: "Réessayer",
    readerInDevelopment: "Lecteur Bible Jean en cours de développement...",
    verseCopied: "Verset copié dans le presse-papiers !",
    moreReferences: "et {{count}} autres références",
    copyright: "📖 LSG 1910 • Strong inclus",
    markAsRead: "Passage lu",
    alreadyRead: "Déjà lu",
    readingBonus: "Bonus de lecture",
    results: "résultats",
    result: "résultat",
    copy: "Copier",
    image: "Image"
  },
  
  mountain: {
    chapter: "Chapitre",
    chapterProgress: "Chapitre {{current}}/{{total}}",
    secret: "Secret!",
    spiritualAscension: "Ascension Spirituelle",
    levelProgress: "Niveau {{level}} • {{stars}} étoiles obtenues",
    combo: "Combo",
    perfectMessage: '"Car mes pensées ne sont pas vos pensées" - L\'agneau gravit vers la sagesse parfaite',
    goodMessage: '"Cherchez et vous trouverez" - La montée continue vers la vérité',
    startMessage: '"La foi, mème petite comme un grain de sénevé" - Premier pas vers la lumiïre',
    skipAnimation: "Passer l'animation",
    stats: {
      points: "pts",
      level: "Niv."
    },
    waypoints: {
      start: "Départ",
      firstSlope: "Premiïre pente", 
      lastSlope: "Derniïre pente"
    },
    status: {
      victory: "Victoire!",
      defeat: "Défaite",
      inProgress: "En progression"
    }
  },
  
  bibleResources: {
    inAppReader: {
      name: "Lire dans l'App",
      description: "Lecteur Bible intégré avec Strong",
      features: {
        offline: "Hors ligne",
        strong: "Numéros Strong",
        navigation: "Navigation"
      }
    }
  },
  
  quotes: {
    wisdom: "La connaissance vraie mène à la sagesse éternelle",
    faith: "Je puis tout par celui qui me fortifie",
    hope: "L'Éternel est mon berger, je ne manquerai de rien",
    love: "Car Dieu a tant aimé le monde...",
    perseverance: "La foi nécessite de la persévérance",
    defeat: "L'échec invite à grandir dans la connaissance"
  },

  philosophy: {
    title: "Dimension philosophique",
    loveOntology: "L'amour comme principe ontologique",
    loveDescription: "Jésus transforme l'amour en fondement métaphysique : aimer Dieu et autrui devient la structure mème de l'ètre authentique. L'amour transcende la morale pour devenir mode d'existence.",
    newCommandment: "Le Nouveau Commandement",
    jesusEmphasizes: "Quand Jésus donne un nouveau commandement, il accentue le verbe aimer",
    loveGod: "Aime Dieu de tout ton cœur",
    loveNeighbor: "Aime ton prochain comme toi-mème",
    lovePriority: "L'amour devient une priorité"
  },

  unity: unityTranslations,

  footer: {
    version: "Version 1.0 • 2024",
    dedication: "Développé pour la gloire de Dieu"
  },

  endCredits: {
    lines: [
      { text: "Tu es arrivé en haut de la montagne", delay: 2000 },
      { text: "Tu as appris beaucoup de choses", delay: 2000 },
      { text: "Ta foi grandit chaque jour", delay: 2000 },
      { text: "Tu vis de belles choses avec Dieu", delay: 2000 },
      { text: "Les difficultés t'aident à grandir", delay: 2000 },
      { text: "Elles montrent ce qui est important", delay: 2000 },
      { text: "Sois humble comme un petit enfant", delay: 2000 },
      { text: "Dieu aime ton cœur simple", delay: 2000 },
      { text: "Dans le calme tu entends Dieu", delay: 2000 },
      { text: "Le jeûne libïre ton esprit", delay: 2000 },
      { text: "Prie et Dieu te guidera", delay: 2000 },
      { text: "L'orgueil cache la vérité", delay: 2000 },
      { text: "La grâce de Dieu est magnifique", delay: 2000 },
      { text: "Elle vient du cœur de Dieu", delay: 2000 },
      { text: "La vraie foi te rend libre", delay: 2000 },
      { text: "Elle t'unit à Dieu pour toujours", delay: 2000 },
      { text: "L'amour peut tout changer", delay: 2000 },
      { text: "Il peut faire des miracles", delay: 2000 },
      { text: "Répïte avec moi", delay: 2000 },
      { text: "Jésus, je te donne mon cœur", delay: 3000 },
      { text: "Tu es mon roi, mon sauveur", delay: 3000 },
      { text: "Viens transformer ma vie", delay: 3000 },
      { text: "Le chemin continue maintenant", delay: 2000 },
      { text: "Partage cette belle lumiïre", delay: 2000 },
      { text: "Vers la vie qui ne finit jamais", delay: 2000 },
      { text: "Garde l'amour dans ton cœur", delay: 3000 },
      { text: "Comme un trésor précieux", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "BRAVO !",
      proud: "ON EST FIER DE TOI",
      courage: "COURAGE VALEUREUX",
      peace: "PORTEUR DE PAIX",
      child: "ENFANT DE DIEU",
      blessing: "QUE DIEU TE BÉNISSE",
      continue: "Continuer"
    }
  },

  validation: {
    pseudoTooShort: "Le pseudo doit contenir au moins 2 caractïres",
    enterPseudo: "Veuillez entrer un pseudo"
  },

  pseudoSetup: {
    title: "Choisissez votre pseudo de joueur",
    profileConfig: "Configuration du Profil",
    connectedWith: "Connecté avec",
    playerPseudo: "Pseudo de Joueur",
    pseudoPlaceholder: "Votre pseudo...",
    pseudoRequirements: "2-20 caractïres • Affiché dans les classements",
    suggestions: "Suggestions",
    confirm: "Confirmer le Pseudo",
    errorConfig: "Erreur lors de la configuration"
  },

  navigation: {
    back: "Retour"
  },

  console: {
    starsUnlocked: "étoiles atteintes ! Déblocage chapitre",
    defeatAnimation: "Défaite... J.C. redescend"
  },

  errors: {
    progressionError: "Erreur de progression",
    invalidProgressionData: "Données de progression invalides:"
  },

  levels: {
    chaptersAndBonus: "8 chapitres + niveau bonus",
    bonusUnlocked: "🎁 NIVEAU BONUS DÉBLOQUÉ ! Tu as atteint la perfection spirituelle !",
    starsToDiscover: "273 {stars} à découvrir",
    starsPerLevel: "3 {stars} par niveau"
  },

  architecture: {
    title: "⚙️ Architecture technique",
    react: {
      name: "React",
      description: "Interface moderne"
    },
    modules: {
      name: "Modules", 
      description: "Chargement dynamique"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Sauvegarde locale"
    },
    tailwind: {
      name: "Tailwind",
      description: "Design responsive"
    }
  },

  gameManager: {
    title: "Sauvegarde de jeu",
    saveLocal: "Sauvegarde locale",
    saveCloud: "Cloud synchronisé",
    saveWaiting: "En attente de connexion",
    lastSave: "Derniïre sauvegarde:",
    never: "Jamais",
    saving: "Sauvegarde...",
    save: "Sauvegarder",
    loadProgress: "Charger",
    loading: "Chargement...",
    autoSaveEnabled: "💾 Sauvegarde automatique activée",
    saveError: "❌ Erreur de sauvegarde",
    gameSaved: "✅ Partie sauvegardée !",
    gameLoaded: "✅ Partie chargée !"
  }
};

export default uiTranslations;
